// extracted by mini-css-extract-plugin
export var logoWrapper = "hz_BS";